import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {
  type LinkToExistingUnitOperationsPlanActionParams,
  useLinkToExistingUnitOperationsPlanAction,
} from './useLinkToExistingUnitOperationsPlanAction';

export type LinkToExistingUnitOperationsPlanButtonProps = LinkToExistingUnitOperationsPlanActionParams;

/**
 * Legacy full-text "Link unit operations" button used by the legacy StudyExecutionHeader (flag-off /
 * out-of-scope studies). The new Mantine header consumes {@link useLinkToExistingUnitOperationsPlanAction}.
 */
export default function LinkToExistingUnitOperationsPlanButton(
  props: LinkToExistingUnitOperationsPlanButtonProps
): JSX.Element {
  const action = useLinkToExistingUnitOperationsPlanAction(props);
  const isDisabled = action.isDisabled ?? false;
  return (
    <Tooltip isDisabled={!isDisabled} text={action.disabledTooltip ?? null}>
      <Button
        dataTestAttrs={action.dataTestAttrs}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MEDIUM}
        onClick={action.onSelect}
        text={action.name}
        icon={action.icon}
        disabled={isDisabled}
      />
    </Tooltip>
  );
}
